import errorsObj from "../exceptions.mjs";
import { capitalize, isString } from "lodash-es";
export const errorsCategories = {
  cart: {
    notActive: "NOT_ACTIVE",
    insufficientStock: "INSUFFICIENT_STOCK",
    maxAllowedQuantity: "MAX_ALLOWED_QUANTITY",
    itemNotSellable: "ITEM_NOT_SELLABLE"
  }
};
const testException = (error, list) => {
  return list.some(
    (item) => item.test(isString(error) ? error : error.message)
  );
};
function forgeException(exception, message) {
  return {
    level: exception.type,
    message
  };
}
export function useExceptions(feature) {
  function resolveException(error) {
    const exceptions = errorsObj[feature];
    if (!exceptions) {
      throw new Error(`There is no exceptions for this feature ${feature}`);
    }
    const keys = Object.keys(exceptions);
    const exception = keys.find(
      (key) => testException(error, exceptions[key].errorList)
    );
    if (exception) {
      return forgeException(
        exceptions[exception],
        exceptions[exception].key ?? exception
      );
    }
    return {
      level: "GREEN",
      message: "NO_EXCEPTION"
    };
  }
  return {
    resolveException,
    ExceptionsMap: errorsObj
  };
}
export function useExceptionsCodes(feature) {
  function resolveException(errors) {
    const exceptions = errorsObj[feature];
    if (!exceptions) {
      throw new Error(`There is no exceptions for this feature ${feature}`);
    }
    const keys = Object.keys(exceptions);
    const targetError = errors[0].code;
    const exception = keys.find(
      (key) => testException(targetError, exceptions[key].errorList)
    );
    if (exception) {
      return forgeException(exceptions[exception], exception);
    }
    return {
      level: "GREEN",
      message: "NO_EXCEPTION"
    };
  }
  return {
    resolveException
  };
}
export function useCompositeExceptions(feature) {
  const { resolveException: resolveExceptionGql } = useExceptions(feature);
  const { resolveException: resolveExceptionCart } = useExceptionsCodes(
    "custom" + capitalize(feature)
  );
  function resolveException(error) {
    const results = [];
    if (error && error?.name === "CombinedError") {
      results.push(resolveExceptionGql(error));
    }
    if (Array.isArray(error)) {
      results.push(resolveExceptionCart(error));
    }
    return results;
  }
  return {
    resolveException
  };
}
